import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type TSourceType = string;
type TSourceTypes = TSourceType[];

type TSentiment = string;
type TSentiments = TSentiment[];
type TLanguage = string;
type TLanguages = TLanguage[];

type TEmotion = string;
type TEmotions = TEmotion[];

type TAuthor = string;
type TAuthors = TAuthor[];

type TLocation = string;
type TLocations = TLocation[];

export interface IDetailStreamLandingOverview {
  sourceTypes: TSourceTypes;
  sentiments: TSentiments;
  languages: TLanguages;
  authors: TAuthors;
  locations: TLocations;
  excludeKeywords: string[];
  includeKeywords: string[];
  keywords: string[];
  mediaList?: string[];
  mediaListOnm?: string[];
  mediaListOfm?: string[];
  emotion?: TEmotions;
  isModalOpen: boolean;
  startDate: string;
  endDate: string;
  metricName: string;
  separationMetricName: 'for' | 'on' | 'none';
  metricValueName: string;
  isUsingDetailStreamTimeFrame: boolean;
  // Token to force refresh queries even if filters are unchanged
  // refreshSearchToken?: number;
  // Pending filters that are not yet applied
  // pendingSourceTypes: TSourceTypes;
  // pendingSentiments: TSentiments;
  // pendingLanguages: TLanguages;
  // pendingAuthors: TAuthors;
  // pendingLocations: TLocations;
  // pendingExcludeKeywords: string[];
  // pendingIncludeKeywords: string[];
  // pendingKeywords: string[];
}

export const initialState: IDetailStreamLandingOverview = {
  sourceTypes: [],
  sentiments: [],
  languages: [],
  authors: [],
  locations: [],
  excludeKeywords: [],
  includeKeywords: [],
  keywords: [],
  mediaList: [],
  mediaListOnm: [],
  mediaListOfm: [],
  emotion: [],
  isModalOpen: false,
  startDate: '',
  endDate: '',
  metricName: '',
  separationMetricName: 'none',
  metricValueName: '',
  isUsingDetailStreamTimeFrame: false

  // refreshSearchToken: 0,
  // Initialize pending filters as empty
  // pendingSourceTypes: [],
  // pendingSentiments: [],
  // pendingLanguages: [],
  // pendingAuthors: [],
  // pendingLocations: [],
  // pendingExcludeKeywords: [],
  // pendingIncludeKeywords: [],
  // pendingKeywords: []
};

export const detailStreamLandingOverview = createSlice({
  name: 'detailStreamLandingOverview',
  initialState,
  reducers: {
    reducerUpdateKeywords: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<string[]>
    ) => {
      state.keywords = action.payload;
    },
    reducerClearKeywords: (state: IDetailStreamLandingOverview) => {
      state.keywords = [];
    },
    reducerUpdateExcludeKeywords: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<string[]>
    ) => {
      state.excludeKeywords = action.payload;
    },
    reducerClearExcludeKeywords: (state: IDetailStreamLandingOverview) => {
      state.excludeKeywords = [];
    },
    reducerUpdateIncludeKeywords: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<string[]>
    ) => {
      state.includeKeywords = action.payload;
    },
    reducerClearIncludeKeywords: (state: IDetailStreamLandingOverview) => {
      state.includeKeywords = [];
    },
    reducerUpdateSourceTypes: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<TSourceTypes>
    ) => {
      state.sourceTypes = action.payload;
    },
    reducerUpdateSentiments: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<TSentiments>
    ) => {
      state.sentiments = action.payload;
    },
    reducerUpdateMetricValueName: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<string>
    ) => {
      state.metricValueName = action.payload;
    },
    reducerUpdateLanguages: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<TLanguages>
    ) => {
      state.languages = action.payload;
    },
    reducerUpdateEmotion: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<TEmotions>
    ) => {
      state.emotion = action.payload;
    },
    reducerUpdateMediaListOnm: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<string[]>
    ) => {
      state.mediaListOnm = action.payload;
    },
    reducerUpdateMediaListOfm: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<string[]>
    ) => {
      state.mediaListOfm = action.payload;
    },
    reducerUpdateAuthors: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<TAuthors>
    ) => {
      state.authors = action.payload;
    },
    reducerUpdateLocations: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<TLocations>
    ) => {
      state.locations = action.payload;
    },
    reducerUpdateStartDate: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<string>
    ) => {
      state.startDate = action.payload;
    },
    reducerUpdateEndDate: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<string>
    ) => {
      state.endDate = action.payload;
    },
    // Pending filter reducers
    // reducerUpdatePendingSourceTypes: (
    //   state: IDetailStreamLandingOverview,
    //   action: PayloadAction<TSourceTypes>
    // ) => {
    //   state.pendingSourceTypes = action.payload;
    // },
    // reducerUpdatePendingSentiments: (
    //   state: IDetailStreamLandingOverview,
    //   action: PayloadAction<TSentiments>
    // ) => {
    //   state.pendingSentiments = action.payload;
    // },
    // reducerUpdatePendingLanguages: (
    //   state: IDetailStreamLandingOverview,
    //   action: PayloadAction<TLanguages>
    // ) => {
    //   state.pendingLanguages = action.payload;
    // },
    // reducerUpdatePendingAuthors: (
    //   state: IDetailStreamLandingOverview,
    //   action: PayloadAction<TAuthors>
    // ) => {
    //   state.pendingAuthors = action.payload;
    // },
    // reducerUpdatePendingLocations: (
    //   state: IDetailStreamLandingOverview,
    //   action: PayloadAction<TLocations>
    // ) => {
    //   state.pendingLocations = action.payload;
    // },
    // reducerUpdatePendingKeywords: (
    //   state: IDetailStreamLandingOverview,
    //   action: PayloadAction<string[]>
    // ) => {
    //   state.pendingKeywords = action.payload;
    // },
    // reducerUpdatePendingExcludeKeywords: (
    //   state: IDetailStreamLandingOverview,
    //   action: PayloadAction<string[]>
    // ) => {
    //   state.pendingExcludeKeywords = action.payload;
    // },
    // reducerUpdatePendingIncludeKeywords: (
    //   state: IDetailStreamLandingOverview,
    //   action: PayloadAction<string[]>
    // ) => {
    //   state.pendingIncludeKeywords = action.payload;
    // },
    reducerOpenModal: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<IDetailStreamLandingOverview>
    ) => {
      state.sourceTypes = action.payload.sourceTypes;
      state.sentiments = action.payload.sentiments;
      state.languages = action.payload.languages;
      state.authors = action.payload.authors;
      state.locations = action.payload.locations;
      state.excludeKeywords = action.payload.excludeKeywords;
      state.includeKeywords = action.payload.includeKeywords;
      state.keywords = action.payload.keywords;
      state.mediaListOnm = action.payload.mediaListOnm;
      state.mediaListOfm = action.payload.mediaListOfm;
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
      state.mediaList = action.payload.mediaList;
      state.emotion = action.payload.emotion;
      state.metricName = action.payload.metricName;
      state.separationMetricName = action.payload.separationMetricName;
      state.metricValueName = action.payload.metricValueName;
      state.isUsingDetailStreamTimeFrame =
        action.payload.isUsingDetailStreamTimeFrame;
      state.isModalOpen = true;
    },
    reducerCloseModal: (state: IDetailStreamLandingOverview) => {
      state.sourceTypes = [];
      state.sentiments = [];
      state.languages = [];
      state.authors = [];
      state.locations = [];
      state.excludeKeywords = [];
      state.includeKeywords = [];
      state.keywords = [];
      state.startDate = '';
      state.endDate = '';
      state.mediaList = [];
      state.mediaListOnm = [];
      state.mediaListOfm = [];
      state.emotion = [];
      state.metricName = '';
      state.separationMetricName = 'for';
      state.metricValueName = '';
      state.isUsingDetailStreamTimeFrame = false;
      state.isModalOpen = false;
    },
    // reducerBumpRefreshSearchToken: (state: IDetailStreamLandingOverview) => {
    //   state.refreshSearchToken = (state.refreshSearchToken || 0) + 1;
    // },
    reducerUpdateAdvanceSearchLandingOverview: (
      state: IDetailStreamLandingOverview,
      action: PayloadAction<IDetailStreamLandingOverview>
    ) => {
      state.sourceTypes = action.payload.sourceTypes;
      state.sentiments = action.payload.sentiments;
      state.languages = action.payload.languages;
      state.authors = action.payload.authors;
      state.locations = action.payload.locations;
      state.excludeKeywords = action.payload.excludeKeywords;
      state.includeKeywords = action.payload.includeKeywords;
      state.keywords = action.payload.keywords;
      state.mediaListOnm = action.payload.mediaListOnm;
      state.mediaListOfm = action.payload.mediaListOfm;
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
      state.mediaList = action.payload.mediaList;
      state.emotion = action.payload.emotion;
      state.metricName = action.payload.metricName;
      state.separationMetricName = action.payload.separationMetricName;
      state.metricValueName = action.payload.metricValueName;
    },
    reducerClearAdvanceSearchLandingOverview: (
      state: IDetailStreamLandingOverview
    ) => {
      state.sourceTypes = [];
      state.sentiments = [];
      state.languages = [];
      state.authors = [];
      state.locations = [];
      state.excludeKeywords = [];
      state.includeKeywords = [];
      state.keywords = [];
      state.mediaList = [];
      state.mediaListOnm = [];
      state.mediaListOfm = [];
      state.emotion = [];
      state.metricName = '';
      state.separationMetricName = 'for';
      state.metricValueName = '';
      // // Also clear pending filters
      // state.pendingSourceTypes = [];
      // state.pendingSentiments = [];
      // state.pendingLanguages = [];
      // state.pendingAuthors = [];
      // state.pendingLocations = [];
      // state.pendingExcludeKeywords = [];
      // state.pendingIncludeKeywords = [];
      // state.pendingKeywords = [];
    }
    // reducerApplyPendingFilters: (state: IDetailStreamLandingOverview) => {
    //   // Apply pending filters to active filters
    //   state.sourceTypes = state.pendingSourceTypes;
    //   state.sentiments = state.pendingSentiments;
    //   state.languages = state.pendingLanguages;
    //   state.authors = state.pendingAuthors;
    //   state.locations = state.pendingLocations;
    //   state.excludeKeywords = state.pendingExcludeKeywords;
    //   state.includeKeywords = state.pendingIncludeKeywords;
    //   state.keywords = state.pendingKeywords;
    // },
    // reducerInitializePendingFilters: (state: IDetailStreamLandingOverview) => {
    //   // Initialize pending filters with current active filters when modal opens
    //   state.pendingSourceTypes = state.sourceTypes;
    //   state.pendingSentiments = state.sentiments;
    //   state.pendingLanguages = state.languages;
    //   state.pendingAuthors = state.authors;
    //   state.pendingLocations = state.locations;
    //   state.pendingExcludeKeywords = state.excludeKeywords;
    //   state.pendingIncludeKeywords = state.includeKeywords;
    //   state.pendingKeywords = state.keywords;
    // }
  }
});

export const {
  reducerClearKeywords,
  reducerClearIncludeKeywords,
  reducerClearExcludeKeywords,
  reducerUpdateKeywords,
  reducerUpdateExcludeKeywords,
  reducerUpdateIncludeKeywords,
  reducerUpdateSourceTypes,
  reducerUpdateSentiments,
  reducerUpdateLanguages,
  reducerUpdateMediaListOnm,
  reducerUpdateMediaListOfm,
  reducerUpdateAuthors,
  reducerUpdateLocations,
  // reducerUpdatePendingSourceTypes,
  // reducerUpdatePendingSentiments,
  // reducerUpdatePendingLanguages,
  // reducerUpdatePendingAuthors,
  // reducerUpdatePendingLocations,
  // reducerUpdatePendingKeywords,
  // reducerUpdatePendingExcludeKeywords,
  // reducerUpdatePendingIncludeKeywords,
  reducerOpenModal,
  reducerCloseModal,
  // reducerBumpRefreshSearchToken,
  reducerUpdateAdvanceSearchLandingOverview,
  reducerClearAdvanceSearchLandingOverview,
  reducerUpdateMetricValueName
  // reducerApplyPendingFilters,
  // reducerInitializePendingFilters
} = detailStreamLandingOverview.actions;

export default detailStreamLandingOverview.reducer;
